export enum postulationStateEnum {
  PENDIENTE = 0,
  FINALISTA = 1,
  PRESELECCIONADO = 2,
  NOSELECCIONADO = 3,
};
